// Waveform peaks per second of source, and the sample rate audio is decoded at (low to keep memory small)
const WAVE_RATE = 50
const WAVE_DECODE_RATE = 3000
// Share of the strip height the waveform may use at 100% volume
export const WAVE_HEADROOM = 0.85
export const MAX_WAVE_POINTS = 2000

// Decoded waveforms are shared between editor instances; decoding runs one at a time
const wave_cache = new Map()
let wave_queue = Promise.resolve()

export function load_waveform (url) {
	if (!wave_cache.has(url)) {
		const job = wave_queue.then(() => decode_waveform(url)).catch(() => null);
		wave_queue = job;
		wave_cache.set(url, job);
	}
	return wave_cache.get(url);
}

function offline_context () {
	const Ctx = window.OfflineAudioContext || window.webkitOfflineAudioContext;
	try {
		return new Ctx(1, 1, WAVE_DECODE_RATE);
	} catch (e) {
		return new Ctx(1, 1, 44100);
	}
}

function decode_waveform (url) {
	return fetch(url)
		.then((res) => {
			if (!res.ok) throw new Error("HTTP " + res.status);
			return res.arrayBuffer();
		})
		.then((data) => new Promise((resolve, reject) => offline_context().decodeAudioData(data, resolve, reject)))
		.then((buffer) => {
			const per = buffer.sampleRate / WAVE_RATE;
			const peaks = new Float32Array(Math.ceil(buffer.length / per));
			for (let c = 0; c < buffer.numberOfChannels; c++) {
				const samples = buffer.getChannelData(c);
				for (let i = 0; i < samples.length; i++) {
					const v = Math.abs(samples[i]);
					const p = Math.floor(i / per);
					if (v > peaks[p]) peaks[p] = v;
				}
			}
			let max = 0;
			for (let i = 0; i < peaks.length; i++) if (peaks[i] > max) max = peaks[i];
			if (max > 0) for (let i = 0; i < peaks.length; i++) peaks[i] /= max;
			return {peaks, rate: WAVE_RATE};
		});
}

// Filled, bottom-anchored step path in a viewBox of `points` x 100
export function wave_path (wave, from, len, points, gain) {
	const peaks = wave.peaks;
	const per = len * wave.rate / points;
	const base = from * wave.rate;
	let d = "M0 100";
	for (let i = 0; i < points; i++) {
		const a = Math.max(0, Math.floor(base + i * per));
		const b = Math.min(peaks.length, Math.max(a + 1, Math.floor(base + (i + 1) * per)));
		let m = 0;
		for (let j = a; j < b; j++) if (peaks[j] > m) m = peaks[j];
		const y = Math.round((100 - m * gain * WAVE_HEADROOM * 100) * 10) / 10;
		d += "L" + i + " " + y + "L" + (i + 1) + " " + y;
	}
	return d + "L" + points + " 100Z";
}
